import { render } from "./hoteldetails.vue?vue&type=template&id=7ef3dfc2"
import script from "./hoteldetails.vue?vue&type=script&lang=js"
export * from "./hoteldetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__